import { Injectable } from '@angular/core';
import { ValidationErrors } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { lastValueFrom, map } from 'rxjs';

import { VALIDATION_MESSAGES } from '../common';

@Injectable({
  providedIn: 'root',
})
export class ValidatorsServiceHelper {
  constructor(private translateService: TranslateService) {}

  async getValidatorErrorMessage(
    validatorName: string,
    validatorErrors?: ValidationErrors,
    messageKey?:string
  ): Promise<string | undefined> {
    let args: string[] = VALIDATION_MESSAGES.get(
      validatorName
    )?.validatorErrorsKey?.map((name) => validatorErrors?.[name]);
    if (args) {
      return await this.stringFormat(
        messageKey ?? VALIDATION_MESSAGES.get(validatorName)?.messageKey,
        ...args
      );
    } else {
      return await this.getTranslations(
        'ERROR_MESSAGES',
        VALIDATION_MESSAGES.get(validatorName)?.messageKey
      );
    }
  }

  async stringFormat(
    messageKey: string | undefined,
    ...args: any[]
  ): Promise<string | undefined> {
    const message = await this.getTranslations('ERROR_MESSAGES', messageKey);
    if (message) {
      return message.replace(/{(\d+)}/g, (match, index) => {
        if (typeof args[index] !== 'undefined') {
          return args[index];
        } else {
          return match;
        }
      });
    }
    return undefined;
  }

  // privates
  private async getTranslations(
    translationParentKey: string,
    translateKey: string
  ): Promise<any> {
    return await lastValueFrom(
      this.translateService
        .get(translationParentKey)
        .pipe(map((translationObj) => translationObj[translateKey]))
    );
  }
}
